/* eslint-disable no-undef */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react/prop-types */
import styled from '@emotion/styled';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Button from 'components/base/Button';
import ToolTipButton from 'components/common/TooltipButton';
import PageLoader from 'components/custom/animate-component/PageLoader';
import apiEndpoints from 'constants/apiEndpoints';
import { AuthContext } from 'context/AuthContext';
import { useFormik } from 'formik';
import { useAlert } from 'providers/AlertModalProvider';
import { useLoading } from 'providers/PageLoadingProvider';
import { useContext, useState } from 'react';
import { Col, Modal, Row } from 'react-bootstrap';
import postData from 'services/postData';
import * as Yup from 'yup';
import { faX } from '@fortawesome/free-solid-svg-icons';
import useConfirmationModal from 'views/challan/coal-iron/useConfirmationModal';

const CustomModal = styled(Modal)`
  background-color: #0000004b;
  backdrop-filter: blur(2px);
  & .modal-dialog {
    margin-right: auto;
    margin-left: auto;
  }
  & .modal-header .btn-close {
    background-color: #ffffff39;
  }
`;

const ConfirmationModal = ({
  show,
  handleClose,
  data,
  handleLoading,
  refreshData,
  punchInPunchOutValue
}) => {
  console.log('🚀 ~ datamsf:', data);
  const { user } = useContext(AuthContext);

  const { acceptCheck, rejectCheck } = useConfirmationModal(
    apiEndpoints.employee.manualPunchChecking,
    'Manual Punch'
  );

  const handleApproval = async value => {
    handleClose();
    acceptCheck(
      data?.punch_master_id,
      {
        status: value,
        mp_approval_id: data?.mp_approval_id,
        punch_master_id: data?.punch_master_id || '',
        approved_by: user.user_id
        // type: data?.type
      },
      handleLoading,
      refreshData
    );
  };

  const handleReject = async value => {
    handleClose();
    rejectCheck(
      data?.punch_master_id,
      {
        status: value,
        mp_approval_id: data?.mp_approval_id,
        punch_master_id: data?.punch_master_id || '',
        approved_by: user.user_id,
        type: data?.type
      },
      handleLoading,
      refreshData
    );
  };
  return (
    <CustomModal
      show={show}
      onHide={handleClose}
      backdrop="static"
      keyboard={false}
      centered
    >
      <Row style={{ maxHeight: 'calc(100vh - 50px)' }}>
        <Col xs={12} lg={12} className="rounded-3">
          <div className="bg-white rounded-3 h-100 d-flex flex-column">
            <Modal.Header
              className="border-0 position-relative pb-0 end-0 dark__text-white px-4 border-bottom d-flex justify-content-between align-items-start"
              closeButton={false}
              // style={{ minWidth: '250px' }}
            >
              <div className="mb-2">
                <h4 className="modal-title mb-2 text-1000">
                  Check Manual Punch
                </h4>
              </div>

              <div>
                <ToolTipButton
                  onClick={handleClose}
                  size="sm"
                  variant="phoenix-secondary"
                  label="Close modal"
                  className="ms-2"
                >
                  <FontAwesomeIcon icon={faX} />
                </ToolTipButton>
              </div>
            </Modal.Header>
            <Modal.Body className="px-4 pb-2">
              <p>
                Are you sure you want to mark this manual attendance as checked
                for a {data.type == 'punch_out' ? 'Punch-Out' : 'Punch-In'}?
              </p>
            </Modal.Body>

            <Modal.Footer
              className={`d-flex justify-content-between flex-wrap-reverse`}
            >
              <Button variant="phoenix-secondary" onClick={handleClose}>
                Cancel
              </Button>
              <div className="d-flex gap-1 justify-content-end">
                <Button
                  variant="phoenix-danger"
                  onClick={() => handleReject('Declined')}
                >
                  Decline
                </Button>
                <Button
                  variant="phoenix-success"
                  onClick={() => handleApproval('Checked')}
                >
                  Accept
                </Button>
              </div>
            </Modal.Footer>
          </div>
        </Col>
      </Row>
    </CustomModal>
  );
};

export default ConfirmationModal;
